import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import React from 'react';
import TOOLBAR_SLIDE_RATING from '@tencent/docs-design-resources/icon/desktop/svg/layout_check_outline_light_24.svg';
import BETA_ICON from '@tencent/docs-design-resources/pc/svg/template_beta_16.svg';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.LAYOUT_SUGGESTION,
    content: i18n.t('排版检查'),
    icon: TOOLBAR_SLIDE_RATING,
};

export const toolbarConfig = {
    id: ActionType.LAYOUT_SUGGESTION_TOOLBAR,
    content: config.content,
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.BEAUTIFY_TAB,
        action: TDWActionType.BEAUTIFY_AUTO_BEAUTIFY_CLK,
        ver3: 1,
    },
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        icon: <div>
            <img src={config.icon} alt={''}/>
            beta
        </div>,
    },
    {
        name: toolbarConfig.id,
        content: '',
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: toolbarConfig.id,
        style: {
            width: 'auto',
        },
        icon: <div>
            <img src={config.icon} />
            <img src={BETA_ICON} style={{ position: 'absolute', top: '-5px' }}/>
        </div>,
        text: toolbarConfig.content,
        tooltip: toolbarConfig.content,
    },
];
